import React, { useEffect } from 'react';
import { ReducerDataState } from 'shared/interface/globalInterface';
import { InitialDetailsDataStructure } from 'components/DetailsPageBoilerplate/types';
import { useDispatch, useSelector } from 'react-redux';
import fetchDetails from 'store/details/actions/fetchDetails';
import { resetState } from 'store/details/actions';
import DetailsPageBoilerplate from 'components/DetailsPageBoilerplate/DetailsPageBoilerplate';
import { fetchAdminDetails, updateAdmin } from 'utils/api/admins';
import { clubAdminDetailsMapper } from 'utils/api/admins/dataMapper';
import { updateClub } from 'utils/api/clubs';
import User from 'auth/User';
import { Layouts, PageLayoutParams } from 'layouts/LayoutProvider';

const ClubAdminProfile: React.FC & PageLayoutParams = () => {
  const fetchedDetails: ReducerDataState<InitialDetailsDataStructure> = useSelector((state: any) => state.details);
  const dispatch = useDispatch();
  const user: User = useSelector((state: any) => state.auth.user);
  const userId = user.id;

  useEffect(() => {
    if (userId) {
      const fetcher = () => fetchAdminDetails(clubAdminDetailsMapper);
      dispatch(fetchDetails(fetcher));
    }

    return () => {
      dispatch(resetState());
    };
  }, [userId, dispatch]);

  return (
    <DetailsPageBoilerplate
      type="Club"
      fetchedDetails={fetchedDetails}
      containerWidth={'xl'}
      onAdminUpdate={updateAdmin}
      onCompanyUpdate={updateClub}
    />
  );
};

ClubAdminProfile.layout = Layouts.PROFILE;

export default ClubAdminProfile;
